var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsscher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7186 120H25.2814L0.142373 94.7186L0 25.8305L25.261 0H94.739L120 25.8305V94.7186L94.7186 120ZM26.1153 117.966H93.8847L117.966 93.8847V26.6441L93.8847 2.0339H26.1153L2.0339 26.6441L2.17627 93.8847L26.1153 117.966Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7682 79.9456L95.0127 81.2474L118.602 94.9382L119.358 93.6365L95.7682 79.9456Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27241 25.8009L0.765625 26.6826L24.3593 40.2441L24.8661 39.3624L1.27241 25.8009Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3568 80.1832L0.90625 93.8702L1.41887 94.7485L24.8694 81.0615L24.3568 80.1832Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.634 40.2305L95.1255 39.356L118.739 25.7899L119.248 26.6848L95.634 40.2305Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8634 0.766361L80.1775 24.4997L81.0585 25.0077L94.7443 1.27437L93.8634 0.766361Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9342 95.2773L25.2473 118.728L26.1256 119.24L39.8125 95.7899L38.9342 95.2773Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8657 119.248L80.2996 95.7764L81.1945 95.2679L94.7402 118.739L93.8657 119.248Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9949 0.892464L25.1204 1.40094L38.8492 25.0145L39.7238 24.506L25.9949 0.892464Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4476 112.434H29.5526L29.4103 112.292L7.83061 90.3051V90.1017L7.68823 30.2237L29.817 7.85083H90.3255L112.312 30.2237V90.3051L90.4476 112.434ZM29.9798 111.417H90.0204L111.295 89.8983V30.5085L89.8984 8.84744H30.2442L8.70518 30.6508L8.84755 89.8983L29.9798 111.417Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7084 104.298H34.2915L34.1491 104.156L15.844 85.5661V34.8407L34.4542 15.9661H85.566L104.176 34.6983V85.5458L85.7084 104.298ZM34.7186 103.281H85.2813L103.159 85.139V35.1254L85.1389 16.9831H34.8609L16.8406 35.2882V85.139L34.7186 103.281Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9493 96.0407H39.173L24.1018 80.8271V39.5797L39.3154 24.2441H80.8272L80.9696 24.3865L95.8984 39.5797V80.8271L80.9493 96.0407ZM39.6001 95.0237H80.5425L94.7798 80.4V40.0068L80.2984 25.261H39.6204L24.9967 40.0068V80.4L39.6001 95.0237Z",
    fill: "#81D8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_1234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsscher);
export default __webpack_public_path__ + "static/media/Asscher.7a6e5ff6ee2663550f85efbdfb17aee8.svg";
export { ForwardRef as ReactComponent };